var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",style:({ width: _vm.width + 'px'}),on:{"click":function($event){$event.stopPropagation();return _vm.clickItem.apply(null, arguments)}}},[_c('v-image',{style:({
            width: _vm.width + 'px',
            height: _vm.height + 'px',
            marginBottom: _vm.marginBottom + 'px'
        }),attrs:{"src":_vm.data.picture,"radius":"50%"}}),_c('div',{staticClass:"item-name line1",style:({
            fontSize: _vm.fontSize + 'px',
            color: _vm.color,
        })},[_vm._v(_vm._s(_vm.data.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }